import React, { useState, useEffect } from "react";

const IndexTable = ({loading,error,indexData}) => {
 

  if (loading) {
    return (
      <div className="text-white text-center py-4">Loading index data...</div>
    );
  }

  if (error) {
    return (
      <div className=" text-center py-4 text-rose-500">Error: {error}</div>
    );
  }

  if (!indexData || indexData.length === 0) {
    return (
      <div className="text-white text-center py-4">No index data available</div>
    );
  }

  return (
    <div className="p-0 text-white w-full h-auto">
      <table className="text-[12px] w-full h-full">
        <thead>
          <tr>
            <th rowSpan={2} className="border  border-gray-300  px-[4px] py-[17px]">Index</th>
            <th rowSpan={2} className="border border-gray-300  px-[4px] py-[17px] text-center">
              M10
            </th>
            <th rowSpan={2} className="border border-gray-300  px-[4px] py-[17px] text-center">
              M20
            </th>
            <th rowSpan={2} className="border border-gray-300  px-[4px] py-[17px] text-center">
              M50
            </th>
            <th rowSpan={2} className="border border-gray-300  px-[4px] py-[17px] text-center">
              PC4
            </th>
            
          </tr>
        </thead>
        <tbody>
          {indexData.map((item, index) => (
            <tr key={index}>
              <td className="border border-gray-300 px-2  py-[2px] min-w-[150px]">
                <div className="flex text-[12px] items-start gap-2">
                  <span className="ml-[3px]">{item.strategy}</span>
                </div>
              </td>

            
              
              <td className="border border-gray-300 px-0 text-[12px] py-[2px] text-center">
                <div className="flex items-center justify-center">
                  {item.ma10}
                </div>
              </td>
              <td className="border border-gray-300 px-0 text-[12px] py-[2px] text-center">
                <div className="flex items-center justify-center">
                  {item.ma20}
                </div>
              </td>
              <td className="border border-gray-300 px-0 text-[12px] py-[2px] text-center">
                <div className="flex items-center justify-center">
                  {item.ma50}
                </div>
              </td>
              <td className="border border-gray-300 px-0 text-[12px] py-[2px] text-center">
                <div className="flex items-center justify-center">
                  {item.pc4}
                </div>
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
};

export default IndexTable;
